import { memo } from 'react';

const DropdownItemWrapper = memo(({ children }: { children: React.ReactNode }) => {
  return <div className="p-1.5 rounded-sm mr-3 my-1">{children}</div>;
});
DropdownItemWrapper.displayName = 'DropdownItemWrapper';
export default DropdownItemWrapper;
